import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConsentBannerComponent } from './consent-banner.component';

@NgModule({
  declarations: [ConsentBannerComponent],
  imports: [CommonModule],
  exports: [ConsentBannerComponent]
})
export class ConsentModule { }
